import { initLogoSlider } from "../modules/logo-slider.js";
jQuery(($) => initLogoSlider($));
